// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark Mode Dashboard Container */
.dashboard-container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    color: #e0e0e0;
    background-color: #121212;
    min-height: 100vh;
}

/* Dashboard Title */
.dashboard-title {
    color: #bb86fc; /* Purple accent color */
    margin-bottom: 30px;
    font-weight: 600;
    border-bottom: 2px solid #333;
    padding-bottom: 10px;
}

/* Tabs Container */
.tabs {
    display: flex;
    margin-bottom: 20px;
    border-bottom: 1px solid #333;
}

/* Tab Buttons */
.tab-button {
    background: none;
    border: none;
    padding: 12px 24px;
    margin-right: 5px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    color: #9e9e9e; /* Medium gray for inactive tabs */
    border-radius: 5px 5px 0 0;
    transition: all 0.3s ease;
    position: relative;
    bottom: -1px;
}

.tab-button:hover {
    color: #bb86fc; /* Purple accent color */
    background-color: #1e1e1e;
}

.tab-button.active {
    color: #ffffff;
    background-color: #1e1e1e;
    border: 1px solid #333;
    border-bottom: 1px solid #1e1e1e;
    font-weight: 600;
}

/* Tab Content */
.tab-content {
    background-color: #1e1e1e;
    border: 1px solid #333;
    border-top: none;
    border-radius: 0 0 5px 5px;
    padding: 25px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

/* Animation for tab transitions */
.tab-content {
    animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Optional: Scrollbar styling for dark mode */
::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    background: #1e1e1e;
}

::-webkit-scrollbar-thumb {
    background: #555;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: #777;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,cAAc,EAAE,wBAAwB;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,kCAAkC;IAClD,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc,EAAE,wBAAwB;IACxC,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,yCAAyC;AAC7C;;AAEA,kCAAkC;AAClC;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,8CAA8C;AAC9C;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* Dark Mode Dashboard Container */\n.dashboard-container {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    color: #e0e0e0;\n    background-color: #121212;\n    min-height: 100vh;\n}\n\n/* Dashboard Title */\n.dashboard-title {\n    color: #bb86fc; /* Purple accent color */\n    margin-bottom: 30px;\n    font-weight: 600;\n    border-bottom: 2px solid #333;\n    padding-bottom: 10px;\n}\n\n/* Tabs Container */\n.tabs {\n    display: flex;\n    margin-bottom: 20px;\n    border-bottom: 1px solid #333;\n}\n\n/* Tab Buttons */\n.tab-button {\n    background: none;\n    border: none;\n    padding: 12px 24px;\n    margin-right: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 500;\n    color: #9e9e9e; /* Medium gray for inactive tabs */\n    border-radius: 5px 5px 0 0;\n    transition: all 0.3s ease;\n    position: relative;\n    bottom: -1px;\n}\n\n.tab-button:hover {\n    color: #bb86fc; /* Purple accent color */\n    background-color: #1e1e1e;\n}\n\n.tab-button.active {\n    color: #ffffff;\n    background-color: #1e1e1e;\n    border: 1px solid #333;\n    border-bottom: 1px solid #1e1e1e;\n    font-weight: 600;\n}\n\n/* Tab Content */\n.tab-content {\n    background-color: #1e1e1e;\n    border: 1px solid #333;\n    border-top: none;\n    border-radius: 0 0 5px 5px;\n    padding: 25px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n/* Animation for tab transitions */\n.tab-content {\n    animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Optional: Scrollbar styling for dark mode */\n::-webkit-scrollbar {\n    width: 8px;\n}\n\n::-webkit-scrollbar-track {\n    background: #1e1e1e;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #555;\n    border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #777;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
